import React from 'react';

import { ExpandableText } from '@/components/ExpandableText';
import { FooterRG } from '@/components/FooterRG';
import { LineSeparator } from '@/components/LineSeparator';
import { PolymarketDisclaimer } from '@/components/PolymarketDisclaimer';
import { Box } from '@/components/lib/components';
import { AppTheme } from '@/components/lib/theme';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';
import { richTextToParagraphs } from '@/utils/parse-prismic-content';
import { SpacingProps } from '@shopify/restyle';

const REGULATORY_LINES = 3;

export const PredictionsFooter = (props: SpacingProps<AppTheme>) => {
    const regulatoryFooter = useJurisdictionStore(
        state => state.jurisdictionSettings?.productConfig?.richTextsSlices?.PredictionsRegulatoryFooter
    );
    const regulatoryText = richTextToParagraphs(regulatoryFooter);

    return (
        <Box marginBottom="s48" {...props}>
            <LineSeparator />
            <Box paddingTop="s40" gap="s20">
                <PolymarketDisclaimer textAlign="left" />
                {regulatoryText ? (
                    <ExpandableText
                        text={regulatoryText}
                        linesToTruncate={REGULATORY_LINES}
                        color="neutral400"
                        toggleColor="neutral300"
                        letterSpacing={-0.08}
                    />
                ) : null}
            </Box>
            <FooterRG marginTop="s40" marginBottom="s0" />
        </Box>
    );
};
